// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-vh {
  height: calc(100vh - 70px);
  min-height: 400px;
}

.href-p {
  text-decoration: underline;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/accountActivation/account-activation.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,iBAAA;AACJ;;AAEA;EACI,0BAAA;EACA,eAAA;AACJ","sourcesContent":[".full-vh {\r\n    height: calc(100vh - 70px);\r\n    min-height: 400px;\r\n}\r\n\r\n.href-p {\r\n    text-decoration: underline;\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
